import DeeplinkChoice from '../../components/Lightbox/DeeplinkChoice';
import SeriesGallery from '../../components/SeriesGallery';
import PacMissing from '../../components/Lightbox/PacMissing';
import IpexGalleryWarning from '../../components/Lightbox/IpexGalleryWarning';
import AmeliorationDialog from '../../components/Lightbox/AmeliorationDialog';

export default {
  DEEPLINK_CHOICE: DeeplinkChoice,
  PAC_MISSING: PacMissing,
  SERIES_GALLERY: SeriesGallery,
  IPEX_GALLERY_WARNING: IpexGalleryWarning,
  AMELIORATION_DIALOG: AmeliorationDialog,
};
